/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {EditParameterModal} from './EditParameterModal'
import {useThemeMode} from '../../../../../_metronic/partials'
import firebase from '../../../../firebase/FirebaseConfig'
import apiConnect from '../../../../api/apiConnect'

const ParameterTableView = () => {
  const db = firebase.firestore()
  const [parameterLists, setParameterLists] = useState([])
  const [digitalOutputLists, setDigitalOutputLists] = useState([])
  const [settingParameterLists, setSettingParameterLists] = useState([])
  const [statusParameterLists, setStatusParameterLists] = useState([])
  const [trigger, setTrigger] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [deviceData, setDeviceData] = useState([])
  const deviceId = useParams().deviceId
  const [limitParameter, setLimitParameter] = useState(60)

  const [showModalEditParameter, setShowModalEditParameter] = useState(false)
  const [selectedParameter, setSelectedParameter] = useState({})
  const {mode} = useThemeMode()

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/parameters/by-device-id/${deviceId}`)
        setParameterLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)
        setLimitParameter(response.data?.limitParameter ? response.data?.limitParameter : 60)
        setDeviceData(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/digital-outputs/by-device-id/${deviceId}`)
        setDigitalOutputLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/setting-parameters/by-device-id/${deviceId}`)
        setSettingParameterLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/status-parameters/by-device-id/${deviceId}`)
        setStatusParameterLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  const combinedArray = parameterLists.concat(
    digitalOutputLists,
    settingParameterLists,
    statusParameterLists
  )

  const columns = [
    {
      name: 'Type',
      selector: (row) => row.type,
      sortable: true,
      cell: (row) => {
        return (
          <p>
            {row.type == 'sensor' ? (
              <span className='badge badge-primary'>Parameter</span>
            ) : row.type == 'setting_parameter' ? (
              <span className='badge badge-info'>Setting Parameter</span>
            ) : row.type == 'status_parameter' ? (
              <span className='badge badge-danger'>Status Parameter</span>
            ) : row.type == 'digital_output' ? (
              <span className='badge badge-warning'>Digital Output</span>
            ) : (
              <span className='badge badge-warning'>{row.type}</span>
            )}
          </p>
        )
      },
    },
    {
      name: 'ID',
      selector: (row) => row.id,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p style={{textDecoration: 'none', color: 'inherit'}}>
              <p className='fs-8'>{row.id}</p>
            </p>
          </>
        )
      },
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <div className='symbol symbol-30px me-2'>
              <img src={row.icon} alt='' />
            </div>
            <Link to={`/device/${deviceId}/parameter/${row.id}`}>
              <p>{row.name}</p>
            </Link>
          </>
        )
      },
    },
    {
      name: 'Status',
      selector: (row) => row.current_status,
      sortable: true,
      cell: (row) => {
        return (
          <p>
            {row.type == 'status_parameter' ? (
              row.current_log.status == 'normal' ? (
                <span className='badge badge-light-success'>Normal</span>
              ) : row.current_log.status == 'abnormal' ? (
                <span className='badge badge-light-danger'>Abnormal</span>
              ) : row.current_log.status == 'offline' ? (
                <span className='badge badge-light-dark'>Offline</span>
              ) : (
                <span className='badge badge-light-dark'>{row.current_log.status}</span>
              )
            ) : row.current_status == 'normal' ? (
              <span className='badge badge-light-success'>Normal</span>
            ) : row.current_status == 'abnormal' ? (
              <span className='badge badge-light-danger'>Abnormal</span>
            ) : row.current_status == 'offline' ? (
              <span className='badge badge-light-dark'>Offline</span>
            ) : (
              <span className='badge badge-light-dark'>{row.current_status}</span>
            )}
          </p>
        )
      },
    },
    {
      name: 'Last Update',
      selector: (row) => row.current_time,
      sortable: true,
      cell: (row) => {
        return (
          <p>
            {row.type == 'status_parameter'
              ? getTimeFormat(row.current_log.timestamp)
              : getTimeFormat(row.current_time)}
          </p>
        )
      },
    },
    {
      name: 'Value',
      selector: (row) => row.current_value,
      sortable: true,
      cell: (row) => {
        return (
          <p>
            {row.type == 'status_parameter' ? (
              <p>{row.current_log.message}</p>
            ) : row.type == 'digital_output' ? (
              <p>{row.current_value}</p>
            ) : (
              <p>{Math.round(row.current_value * 100) / 100}</p>
            )}
          </p>
        )
      },
    },
    {
      name: 'Min/Max',
      selector: (row) => row.type,
      sortable: true,
      cell: (row) => {
        return (
          <p>
            {row.type == 'status_parameter' ? (
              <p>-</p>
            ) : (
              <p>
                {row.min} / {row.max}
              </p>
            )}
          </p>
        )
      },
    },
    {
      name: 'Action',
      selector: (row) => row.type,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <div
              className='btn btn-secondary btn-sm'
              onClick={() => {
                setShowModalEditParameter(true)
                setSelectedParameter(row)
              }}
            >
              <i className='fas fa-gear fs-5 me-2'></i>
              Options
            </div>

            {/* {row.type == 'sensor' ? (
              <>
                <Dropdown>
                  <Dropdown.Toggle variant='light' size='sm'>
                    Options
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        setShowModalEditParameter(true)
                        setSelectedParameter(row)
                      }}
                    >
                      <i className='fas fa-pen-to-square me-3 ms-2'></i>
                      <span>Edit</span>
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => handleRemoveParameter(row)}>
                      <i className='fas fa-trash-can me-3 ms-2'></i>
                      <span>Delete</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            ) : row.type == 'setting_parameter' ? (
              <>
                <Dropdown>
                  <Dropdown.Toggle variant='light' size='sm'>
                    Options
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleRenameSettingParameter(row)}>
                      <i className='fas fa-pen-to-square me-3 ms-2'></i>
                      <span>Edit</span>
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => handleRemoveSettingParameter(row)}>
                      <i className='fas fa-trash-can me-3 ms-2'></i>
                      <span>Delete</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            ) : row.type == 'status_parameter' ? (
              <>
                <Dropdown>
                  <Dropdown.Toggle variant='light' size='sm'>
                    Options
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleRenameStatusParameter(row)}>
                      <i className='fas fa-pen-to-square me-3 ms-2'></i>
                      <span>Edit</span>
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => handleRemoveStatusParameter(row)}>
                      <i className='fas fa-trash-can me-3 ms-2'></i>
                      <span>Delete</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            ) : (
              ''
            )} */}
          </>
        )
      },
    },
  ]

  // เพิ่มการกรองข้อมูลบน DataTable ก่อนแสดงผล
  const filteredData = combinedArray.filter(
    (parameter) =>
      parameter.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      parameter.id.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
          <div className='d-flex justify-content-md-end justify-content-start w-100'>
            <div className='input-group w-100 w-md-auto'>
              <span className='input-group-text'>
                <i className='fas fa-search'></i>
              </span>
              <input
                type='text'
                className='form-control'
                placeholder='Search...'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className='card-body border-top py-3'>
          <div className='table-responsive' style={{borderRadius: '10px'}}>
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              paginationPerPage={20}
              paginationRowsPerPageOptions={[20, 50, 100]}
              keyField='parameterId'
              theme={mode === 'dark' ? 'dark' : 'light'}
            />
          </div>
        </div>
      </div>

      <EditParameterModal
        showModalEditParameter={showModalEditParameter}
        setShowModalEditParameter={setShowModalEditParameter}
        selectedParameter={selectedParameter}
        trigger={trigger}
        setTrigger={setTrigger}
      />
    </>
  )
}

export {ParameterTableView}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
